module.exports = {
    liaisonFilter: {
        rules: [
            { name: 'required', fields: ['localLiaison', 'zipCode'], required: true },
            { name: 'five numbers only', fields: ['zipCode'],
                validators: [/^\d{5}$/] }
        ],
    }

};
